import { Component, OnInit, Input } from '@angular/core';
import { EncuestaCovidPreguntaDetalleEntity, EncuestaCovidPreguntaEntity, EncuestaCovidRespuestaEntity } from '../../../../services/servicio-encuesta-covid.service';
import { AfiliadoEntity } from '../../../../services/servicio-afiliado.service';

@Component({
  selector: 'app-grupo-pregunta',
  templateUrl: './grupo-pregunta.component.html',
  styleUrls: ['./grupo-pregunta.component.css']
})
export class GrupoPreguntaComponent implements OnInit {

  public preguntasDetalle: EncuestaCovidPreguntaDetalleEntity[] = [];

  @Input() public grupoPregunta: EncuestaCovidPreguntaEntity;
  @Input() public resultados: EncuestaCovidRespuestaEntity [];
  @Input() public afiliado: AfiliadoEntity;

  constructor() { }

  ngOnInit() {
    this.build();
  }

  build() {
    // Preguntas padre
    let preguntasDetalle = this.grupoPregunta.preguntasDetalle.filter((d: EncuestaCovidPreguntaDetalleEntity) => {
      const padre = d.idPadrePreguntaDetalle === 0;
      if(padre) {
        return this.isSexoPregunta(d.sexo);
      } else {
        return false;
      }
    });

    if(preguntasDetalle && preguntasDetalle.length > 0) {
      // Se organizan preguntas padre
      preguntasDetalle = preguntasDetalle.sort((a: EncuestaCovidPreguntaEntity, b: EncuestaCovidPreguntaDetalleEntity) => a.orden - b.orden);

      // Calculas preguntas hijo
      for(let i = 0; i < preguntasDetalle.length ; i++) {
        const p = preguntasDetalle[i].id;
        preguntasDetalle[i].preguntasDetalleRelacion = this.grupoPregunta.preguntasDetalle.filter((d: EncuestaCovidPreguntaDetalleEntity) => d.idPadrePreguntaDetalle === p);
        preguntasDetalle[i].resultado = this.resultados.find((d: EncuestaCovidRespuestaEntity) => d.idFormatoPreguntaDetalle === p);
      }
    }

    this.preguntasDetalle = preguntasDetalle;
  }

  isSexoPregunta(sexoPregunta: string): boolean {
    return sexoPregunta.toUpperCase() === 'A' || sexoPregunta.trim().toUpperCase() == this.afiliado.codigoSexo.trim().toUpperCase();
  }

}
